module.exports = __webpack_public_path__ + "static/media/classification_comp.22ab21da.gif";